module.exports = __webpack_public_path__ + "static/media/gnt.0f6f1d80.svg";